// extracted by mini-css-extract-plugin
export default {"container":"container__3FGQ5","title-box":"title-box__z6kkg","description-box":"description-box__M0ZQs","helper":"helper__brY5l","description-input":"description-input__tHGSV"};